/**
 * 슬립케어: Node `routes/sleepCarePortone.js` → `GET /api/sleep-care/payment/:paymentId`
 * (서버에서 PortOne SDK 조회, 시크릿은 PORTONE_API_SECRET 만 서버에 둠)
 *
 * CRA와 API 포트가 다르면 `.env.local` 에 예:
 * REACT_APP_SOMNI_API_BASE_URL=http://localhost:3000
 */
export async function fetchPortOnePayment(paymentId) {
  const origin = (process.env.REACT_APP_SOMNI_API_BASE_URL || '').replace(/\/$/, '');
  const url = `${origin}/api/sleep-care/payment/${encodeURIComponent(paymentId)}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  const text = await res.text();
  if (!res.ok) {
    let message = `PortOne 결제 조회 실패 (HTTP ${res.status})`;
    try {
      const j = JSON.parse(text);
      if (j.message) message = j.message;
    } catch {
      /* ignore */
    }
    throw new Error(text ? `${message}: ${text}` : message);
  }

  try {
    return JSON.parse(text);
  } catch {
    throw new Error('PortOne 결제 응답이 올바른 JSON이 아닙니다.');
  }
}
